import axios from '@/axios.js';

export default {
  methods: {
    async removeLogo(id) {
      try {
        const response = await axios.post('remove-logo', { site_id: id });
        if (response.data) {
          this.$vs.notify({
            title: this.$t('harmony.social-deletedLogo-title'),
            text: this.$t('harmony.social-deletedLogo-text'),
            color: 'success',
            icon: 'check_box',
            position: 'bottom-center',
            time: 5000,
          })
          const slug = this.$route.params.slug;
          await this.loadHarmony(slug);
        }
      } catch (error) {
        console.log(error)
      }
    },

    async removeBackground(value) {
      try {
        const response = await axios.post('remove-background', { background: value });
        if (response.data) {
          this.$vs.notify({
            title: this.$t('harmony.social-deletedBackground-title'),
            text: this.$t('harmony.social-deletedBackground-text'),
            color: 'success',
            icon: 'check_box',
            position: 'bottom-center',
            time: 5000,
          });

          Object.keys(this.site_setting.backgrounds).forEach(key => {
            if (this.site_setting.backgrounds[key].path === value) {
              this.site_setting.backgrounds[key].path = '';
            }
          });

          if (this.site_setting.page.background === value || this.site_setting.page.background?.path === value || (this.select === 'logo' && this.site_setting.page.background)) {
            this.site_setting.page.background = '';
          }

          this.saveSettings()
        }
      } catch (error) {
        console.log(error)
      }
      this.removeBackgroundColor()
    },

    async handleImageUploaded() {
      const slug = this.$route.params.slug;
      await this.loadHarmony(slug);
      this.menu_editor = true
      this.showDetailsPlatform = true;
    },

    async handleVideoUploaded() {
      const slug = this.$route.params.slug;
      await this.loadHarmony(slug);
    },

    async removeVideo(value) {
      try {
        const response = await axios.post('remove-video', { video: value });
        if (response.data) {
          this.$vs.notify({
            title: this.$t('harmony.social-videoRemoved-title'),
            text: this.$t('harmony.social-videoRemoved-text'),
            color: 'success',
            icon: 'check_box',
            position: 'bottom-center',
            time: 5000,
          });

          Object.keys(this.site_setting.videos).forEach(key => {
            if (this.site_setting.videos[key].path === value) {
              this.site_setting.videos[key].path = '';
              this.site_setting.videos[key].show = true;
            }
          });

          if (this.site_setting.page.videos == value) {
            this.site_setting.page.videos = ''
          }
          this.saveSettings()
        }
      } catch (error) {
        console.log(error)
      }
    },

    async removeGallery(value) {
      try {
        const response = await axios.post('remove-gallery', { gallery: value });
        if (response.data) {
          this.$vs.notify({
            title: this.$t('harmony.gallery-title-remove'),
            text: this.$t('harmony.gallery-text-remove'),
            color: 'success',
            icon: 'check_box',
            position: 'bottom-center',
            time: 5000,
          });

          Object.keys(this.site_setting.galleries).forEach(key => {
            if (this.site_setting.galleries[key].id == value) {
              this.site_setting.galleries[key] = { id: null, images: [] }
            }
          });
          this.saveSettings()
        }
      } catch (error) {
        console.log(error)
      }
    },

    async removeSchedules(section) {
      this.showDetailsPlatform = true
      const formData = new FormData();
      formData.append("section", section);
      formData.append("site_id", this.harmony.id);
      try {
        const response = await axios.post('/remove-schedules', formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
          },
          onUploadProgress: (progressEvent) => {
            this.uploadProgress = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
          },
        });
        if (response) {
          this.$vs.notify({
            title: this.$t("imageUpload.uploadCard-title"),
            text: this.$t("imageUpload.uploadCard-text"),
            color: "success",
            icon: "check_box",
            position: "bottom-center",
            time: 5000,
          });
        }
        this.site_setting.schedules[`card${this.cardSelect}`].background = '';
        this.saveSettings()
      } catch (error) {
        this.uploadProgress = 0;
        this.imagePreview = null;
        this.file = null;
        this.$vs.notify({
          title: this.$t("imageUpload.uploadError-title"),
          text: this.$t("imageUpload.uploadError-text"),
          color: "danger",
          icon: "warning",
          position: "bottom-center",
          time: 5000,
        });
        console.error("Upload Error:", error);
      }
    },

    removeLastSchedule(section) {
      const schedule = this.site_setting.schedules[section];
      if (schedule && schedule.schedule && schedule.schedule.length > 0) {
        schedule.schedule.pop();
        this.saveSettings();
      }
    }
  }
}
